import React, { useEffect, useState } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import Form from 'react-bootstrap/Form';
import Button from '../buttons/button';
import {
    useCreateSurveCategoryMutation,
    useUpdateSurveCategoryMutation,
    useGetAllSurveyCategoriesIdQuery,
} from '../../../app/surveyApi/surveyCategoryApi';
import { showToast } from '../../../helpers/Utils';

const AddSurveyCategoryModal = ({ show, setShow, handleClose, surveyCategoryId }) => {
    const [formData, setFormData] = useState({
        survey_category_title: '',
        survey_category_image: null,
    });
    const [imagePreview, setImagePreview] = useState(null);

    const [createSurveyCategory, { isLoading: isCreating }] = useCreateSurveCategoryMutation();
    const [updateSurveyCategory, { isLoading: isUpdating }] = useUpdateSurveCategoryMutation();

    const {
        data: editData,
        isFetching: isFetchingCategory,
    } = useGetAllSurveyCategoriesIdQuery({ surveyCategoryId }, { skip: !surveyCategoryId });

    useEffect(() => {
        if (surveyCategoryId && editData?.data) {
            setFormData({
                survey_category_title: editData.data.survey_category_title || '',
                survey_category_image: null, // Start fresh
            });
            setImagePreview(editData.data.survey_category_image || null);
        } else {
            setFormData({
                survey_category_title: '',
                survey_category_image: null,
            });
            setImagePreview(null);
        }
    }, [surveyCategoryId, editData, show]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({ ...prev, survey_category_image: file }));
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.survey_category_title.trim()) {
            showToast('Survey category title is required', 'error');
            return;
        }

        try {
            const payload = new FormData();
            payload.append('survey_category_title', formData.survey_category_title);
            payload.append('isActive', true);
            if (formData.survey_category_image) {
                payload.append('survey_category_image', formData.survey_category_image);
            }

            if (surveyCategoryId) {
                await updateSurveyCategory({ surveyCategoryId, body: payload }).unwrap();
                showToast('Survey category updated successfully', 'success');
            } else {
                await createSurveyCategory({ formData: payload }).unwrap();
                showToast('Survey category added successfully', 'success');
            }

            handleClose();
        } catch (err) {
            console.log(err,"err");
            
            showToast(err?.data?.loggedError ||     err?.data?.message || 'Something went wrong', 'error');
        }
    };

    return (
        <CommonModal
            show={show}
            setShow={setShow}
            handleClose={handleClose}
            title={surveyCategoryId ? 'Edit Survey Category' : 'Add Survey Category'}
        >
            {surveyCategoryId && isFetchingCategory ? (
                <div className="text-center py-4">Loading category...</div>
            ) : (
                <Form onSubmit={handleSubmit} encType="multipart/form-data">
                    <Form.Group className="mb-3">
                        <Form.Label>Survey Category Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter category title"
                            value={formData.survey_category_title}
                            name="survey_category_title"
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    survey_category_title: e.target.value,
                                }))
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Category Image</Form.Label>
                        <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                        {imagePreview && (
                            <div className="mt-2">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                                />
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-3">
                        <Button label="Cancel" className="borderedBtn" onClick={handleClose} />
                        <Button type="submit" label={isCreating || isUpdating ? 'Saving...' : 'Save'} />
                    </div>
                </Form>
            )}
        </CommonModal>
    );
};

export default AddSurveyCategoryModal;
